module.exports = __webpack_public_path__ + "static/media/NavBarBackground.710ab495.svg";